import React, { useState, useEffect } from 'react';
import styles from './AddUser.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { createUser } from '../../Redux/Actions/actions';
import { useNavigate } from 'react-router-dom';

// Función para calcular el vencimiento de cuota al mismo día del mes siguiente o último día si no existe
function getNextMonthSameDayOrLast(day = new Date()) {
  const year = day.getFullYear();
  const month = day.getMonth();
  const date = day.getDate();

  // Próximo mes (si es diciembre, pasa a enero del siguiente año)
  const nextMonth = month === 11 ? 0 : month + 1;
  const nextYear = month === 11 ? year + 1 : year;

  // Último día del próximo mes
  const lastDayNextMonth = new Date(nextYear, nextMonth + 1, 0).getDate();

  // Si el día actual existe en el próximo mes, úsalo; si no, usa el último día
  const newDate = Math.min(date, lastDayNextMonth);

  const result = new Date(nextYear, nextMonth, newDate);
  return result.toISOString().split('T')[0];
}
const initialForm = {
  dni: '',
  name: '',
  last_name: '',
  email: '',
  phone_number: '',
  birth_date: '',
  gender: '',
  address: '',
  emergency_contact_name: '',
  emergency_contact_phone: '',
  cuotaPaga: false,
  cuota_vencimiento: getNextMonthSameDayOrLast(),
  monday: false,
  tuesday: false,
  wednesday: false,
  thursday: false,
  friday: false,
  saturday: false,
  sunday: false,
  status: true,
  observations: '',
  photo: '',
  registration_date: '',
};

const AddUser = () => {
  const dispatch = useDispatch();
  const { userLoading, userError, userCreated } = useSelector(state => state);
  const gym = useSelector(state => state.gym);
  const navigate = useNavigate();

  const [form, setForm] = useState(initialForm);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value
    });
  };

    useEffect(() => {
    if (userCreated) {
      navigate('/home');
    }
    if (userError) {
      alert(userError);
    }
  }, [userCreated, userError, navigate]);

  const handleSubmit = e => {
    e.preventDefault();
    if (!gym?.id) return alert('No se encontró el gimnasio logueado');
    dispatch(createUser({ ...form, gymId: gym.id }));
  };

  return (
    <div className={styles.container}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <h2>Alta de Socio</h2>

        <label className={styles.label} htmlFor="dni">DNI</label>
        <input id="dni" name="dni" placeholder="DNI" value={form.dni} onChange={handleChange} required />

        <label className={styles.label} htmlFor="name">Nombre</label>
        <input id="name" name="name" placeholder="Nombre" value={form.name} onChange={handleChange} required />

        <label className={styles.label} htmlFor="last_name">Apellido</label>
        <input id="last_name" name="last_name" placeholder="Apellido" value={form.last_name} onChange={handleChange} required />

        <label className={styles.label} htmlFor="email">Email</label>
        <input id="email" name="email" placeholder="Email" value={form.email} onChange={handleChange} required />

        <label className={styles.label} htmlFor="phone_number">Teléfono</label>
        <input id="phone_number" name="phone_number" placeholder="Teléfono" value={form.phone_number} onChange={handleChange} required />

        <label className={styles.label} htmlFor="birth_date">Fecha de nacimiento</label>
        <input id="birth_date" name="birth_date" type="date" placeholder="Fecha de nacimiento" value={form.birth_date} onChange={handleChange} required />

        <label className={styles.label} htmlFor="gender">Género</label>
        <select id="gender" name="gender" value={form.gender} onChange={handleChange} required>
          <option value="">Género</option>
          <option value="Femenino">Femenino</option>
          <option value="Masculino">Masculino</option>
          <option value="Otro">Otro</option>
        </select>

        <label className={styles.label} htmlFor="address">Dirección</label>
        <input id="address" name="address" placeholder="Dirección" value={form.address} onChange={handleChange} required />

        <label className={styles.label} htmlFor="emergency_contact_name">Contacto de emergencia</label>
        <input id="emergency_contact_name" name="emergency_contact_name" placeholder="Contacto de emergencia" value={form.emergency_contact_name} onChange={handleChange} required />

        <label className={styles.label} htmlFor="emergency_contact_phone">Teléfono de emergencia</label>
        <input id="emergency_contact_phone" name="emergency_contact_phone" placeholder="Teléfono de emergencia" value={form.emergency_contact_phone} onChange={handleChange} required />

        <label className={styles.label}>Cuota paga</label>
        <label className={styles.checkboxLabel}>
          <input type="checkbox" name="cuotaPaga" checked={form.cuotaPaga} onChange={handleChange} />
          Cuota paga
        </label>

        <label className={styles.label} htmlFor="cuota_vencimiento">Vencimiento de cuota</label>
        <input
          id="cuota_vencimiento"
          name="cuota_vencimiento"
          type="date"
          placeholder="Vencimiento de cuota"
          value={form.cuota_vencimiento}
          onChange={handleChange}
          required
        />

        <label className={styles.label}>Días de asistencia</label>
        <div className={styles.days}>
          <label><input type="checkbox" name="monday" checked={form.monday} onChange={handleChange} />Lunes</label>
          <label><input type="checkbox" name="tuesday" checked={form.tuesday} onChange={handleChange} />Martes</label>
          <label><input type="checkbox" name="wednesday" checked={form.wednesday} onChange={handleChange} />Miércoles</label>
          <label><input type="checkbox" name="thursday" checked={form.thursday} onChange={handleChange} />Jueves</label>
          <label><input type="checkbox" name="friday" checked={form.friday} onChange={handleChange} />Viernes</label>
          <label><input type="checkbox" name="saturday" checked={form.saturday} onChange={handleChange} />Sábado</label>
          <label><input type="checkbox" name="sunday" checked={form.sunday} onChange={handleChange} />Domingo</label>
        </div>

        <label className={styles.label} htmlFor="observations">Observaciones</label>
        <input id="observations" name="observations" placeholder="Observaciones" value={form.observations} onChange={handleChange} />

        <label className={styles.label} htmlFor="photo">URL de foto</label>
        <input id="photo" name="photo" placeholder="URL de foto" value={form.photo} onChange={handleChange} />

        <label className={styles.label} htmlFor="registration_date">Fecha de alta</label>
        <input id="registration_date" name="registration_date" type="date" placeholder="Fecha de alta" value={form.registration_date} onChange={handleChange} required />

        <button type="submit" disabled={userLoading}>
          {userLoading ? 'Guardando...' : 'Guardar socio'}
        </button>
        {userError && <p className={styles.error}>{userError}</p>}
        {userCreated && <p className={styles.success}>¡Socio creado correctamente!</p>}
      </form>
    </div>
  );
};

export default AddUser;